const getIdError = (id, type) =>
  typeof id !== "string" ||
  !id.match(/^[0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/)
    ? `${type} (${id}) should be a valid guid`
    : undefined;

export default getIdError;
